import packageJson from '../package.json'

/** Canonical release identity for the client bundle. */
export const CLIENT_VERSION = packageJson.version

/** Expected API release paired with this client build. The health response replaces this when online. */
export const SERVER_VERSION = packageJson.version
